
import { supabase } from '@/integrations/supabase/client';

export const fetchUserProfile = async (userId: string) => {
  console.log("Fetching profile for user ID:", userId);
  try {
    // Use a simple query approach without dot notation
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) {
      console.error("Error fetching profile:", error);
      throw error;
    }

    console.log("Profile data:", profile);
    return profile;
  } catch (error) {
    console.error("Error in fetchUserProfile:", error);
    throw error;
  }
};

// Add a function to update mature content settings using the centralized service
export const updateUserMatureContentSettings = async (userId: string, enableMatureContent: boolean, ageVerified: boolean) => {
  console.log("Updating mature content settings for user ID:", userId, { enableMatureContent, ageVerified });
  try {
    const { default: MatureContentService } = await import('@/services/mature-content-service');
    
    const settings = {
      ageVerified,
      matureContentEnabled: enableMatureContent
    };
    
    await MatureContentService.updateSettings(userId, settings);
    
    console.log("Successfully updated mature content settings via service");
    return settings;
  } catch (error) {
    console.error("Error in updateUserMatureContentSettings:", error);
    throw error;
  }
};
